import styled from 'styled-components';
import { IconButton } from '@mui/material';

export const ButtonInfo = styled(IconButton)`
  &&& {
    color: ${({ theme }) => theme.pantone2726C};
  }
`;
export const Label = styled.span`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.pantoneBlack};
  margin-left: 0.4rem;
`;

